import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUcusListe_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUcusListe_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  BirAyOncesiBirAySonrasi: any;
  BirAyOncesiBirAySonrasi_dummy: any;
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetYetki: any;
  GetYetki_dummy: any;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  UcusListe: any[];
  UcusListe_dummy: any[];
  isComp385716Visible: "visible" | "hidden";
  isComp124894Visible: "visible" | "hidden";
  isComp507444Visible: "visible" | "hidden";
  isComp786878Visible: "visible" | "hidden";
  isComp790021Visible: "visible" | "hidden";
  isComp226151Visible: "visible" | "hidden";
  isComp216473Visible: "visible" | "hidden";
  isComp147697Visible: "visible" | "hidden";
}

export class UcusListe_ScreenBase extends React.PureComponent<
  IUcusListe_ScreenProps,
  any
> {
  ucusliste_399769_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "60ba4a63-06c5-4097-a8b1-5015d4263ca4",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 923160, PropertyName: "value", Value: "Uçuş Listesi" },
        { Id: 385716, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 837716, PropertyName: "value", Value: "Uçuş Durumu:" },
        { Id: 240898, PropertyName: "label", Value: "Onay Bekliyor" },
        { Id: 153714, PropertyName: "label", Value: "Onay Verildi" },
        { Id: 257924, PropertyName: "value", Value: "Masraf Durumu:" },
        { Id: 56979, PropertyName: "label", Value: "Giriş Bekliyor" },
        { Id: 590992, PropertyName: "label", Value: "Giriş Yapıldı" },
        { Id: 667090, PropertyName: "label", Value: "Tamamlandı" },
        { Id: 64097, PropertyName: "label", Value: "Onaylı" },
        { Id: 364859, PropertyName: "label", Value: "Reddedildi" },
        { Id: 848050, PropertyName: "value", Value: "Tarih Aralığı:" },
        {
          Id: 191557,
          PropertyName: "startDatePlaceholder",
          Value: "Başlangıç",
        },
        { Id: 191557, PropertyName: "endDatePlaceholder", Value: "Bitiş" },
        { Id: 723449, PropertyName: "label", Value: "Silinen Kayıtlar" },
        { Id: 135352, PropertyName: "label", Value: "Listele" },
        {
          Id: 399769,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 6872087, PropertyName: "title", Value: "Uçuş No" },
        { Id: 6476116, PropertyName: "value", Value: "[datafield:ucusno]" },
        { Id: 6694941, PropertyName: "title", Value: "Rezervasyon No" },
        {
          Id: 2259155,
          PropertyName: "value",
          Value: "[datafield:rezervasyonno]",
        },
        { Id: 511041, PropertyName: "title", Value: "Kalkış Nokta" },
        {
          Id: 32133,
          PropertyName: "value",
          Value: "[datafield:kalkisnoktaaciklama]",
        },
        { Id: 972953, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 5492710, PropertyName: "title", Value: "Varış Nokta" },
        {
          Id: 9067523,
          PropertyName: "value",
          Value: "[datafield:varisnoktaaciklama]",
        },
        { Id: 7559311, PropertyName: "title", Value: "Motor Çalıştırma" },
        {
          Id: 3046555,
          PropertyName: "value",
          Value: "[datafield:motorcalistirma]",
        },
        { Id: 9350491, PropertyName: "title", Value: "Motor Susturma" },
        {
          Id: 7317383,
          PropertyName: "value",
          Value: "[datafield:motorsusturma]",
        },
        { Id: 6388779, PropertyName: "title", Value: "İniş Taco" },
        { Id: 3099204, PropertyName: "value", Value: "[datafield:tolanding]" },
        { Id: 313515, PropertyName: "title", Value: "Son Taco" },
        { Id: 580156, PropertyName: "value", Value: "[datafield:sontaco]" },
        { Id: 587192, PropertyName: "placeholder", Value: "15" },
        { Id: 5566975, PropertyName: "title", Value: "Uçuş Tipi" },
        { Id: 5326431, PropertyName: "value", Value: "[datafield:ucustipi]" },
        { Id: 72783, PropertyName: "title", Value: "Onay Durumu" },
        { Id: 4983520, PropertyName: "title", Value: "Onaylayan" },
        { Id: 1178565, PropertyName: "value", Value: "[datafield:onaylayan]" },
        { Id: 5046063, PropertyName: "title", Value: "Mürettebat" },
        { Id: 5960956, PropertyName: "value", Value: "[datafield:murettebat]" },
        { Id: 11474, PropertyName: "title", Value: "Sorumlu Pilot" },
        { Id: 193880, PropertyName: "value", Value: "[datafield:pilot]" },
        { Id: 889760, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 567614, PropertyName: "title", Value: "Müşteri Şirketler" },
        { Id: 382057, PropertyName: "value", Value: "[datafield:sirketler]" },
        { Id: 365466, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 2789586, PropertyName: "title", Value: "Yolcular" },
        { Id: 9602969, PropertyName: "value", Value: "[datafield:yolcular]" },
        { Id: 734677, PropertyName: "title", Value: "Yolcu Adet" },
        { Id: 167995, PropertyName: "value", Value: "[datafield:yolcuadet]" },
        { Id: 219036, PropertyName: "placeholder", Value: "15" },
        { Id: 809813, PropertyName: "title", Value: "Masraf Çeşitleri" },
        {
          Id: 616295,
          PropertyName: "value",
          Value: "[datafield:masrafcesitleri]",
        },
        { Id: 850403, PropertyName: "title", Value: "Masraf Durumu" },
        {
          Id: 692294,
          PropertyName: "value",
          Value: "[datafield:masrafdurumad]",
        },
        { Id: 160323, PropertyName: "title", Value: "Masraf Adet" },
        { Id: 799202, PropertyName: "value", Value: "[datafield:masrafadet]" },
        { Id: 971470, PropertyName: "placeholder", Value: "15" },
        { Id: 396038, PropertyName: "title", Value: "Masraf TRY" },
        { Id: 154759, PropertyName: "value", Value: "[datafield:masraftry]" },
        { Id: 264164, PropertyName: "title", Value: "Masraf EUR" },
        { Id: 439830, PropertyName: "value", Value: "[datafield:masrafeur]" },
        { Id: 14733, PropertyName: "title", Value: "Masraf USD" },
        { Id: 954774, PropertyName: "value", Value: "[datafield:masrafusd]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.ucusliste_385716_value_kuikaTextInputRef = React.createRef();
    this.ucusliste_399769_value_kuikaTableRef = React.createRef();
    this.ucusliste_972953_value_kuikaTextInputRef = React.createRef();
    this.ucusliste_889760_value_kuikaTextInputRef = React.createRef();
    this.ucusliste_365466_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      BirAyOncesiBirAySonrasi: "",
      SetValueOf: "",
      GetYetki: "",
      TriggerEvent: "",
      UcusListe: [],
      isComp385716Visible: "hidden",
      isComp124894Visible: "hidden",
      isComp507444Visible: "hidden",
      isComp786878Visible: "hidden",
      isComp790021Visible: "hidden",
      isComp226151Visible: "hidden",
      isComp216473Visible: "hidden",
      isComp147697Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("ucusliste", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.UcusListePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("ucusliste", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "FLYASISTAN",
      "FLYPILOT",
      "FLYMALIISLER",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("ucusliste", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.UcusListePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      ucusliste_240898_checked: true,
      ucusliste_153714_checked: true,
      ucusliste_56979_checked:
        this.props.screenInputs.MasrafDurum0 ??
        this.props.screenInputs.masrafdurum0,
      ucusliste_590992_checked:
        this.props.screenInputs.MasrafDurum1 ??
        this.props.screenInputs.masrafdurum1,
      ucusliste_667090_checked:
        this.props.screenInputs.MasrafDurum2 ??
        this.props.screenInputs.masrafdurum2,
      ucusliste_64097_checked:
        this.props.screenInputs.MasrafDurum3 ??
        this.props.screenInputs.masrafdurum3,
      ucusliste_364859_checked:
        this.props.screenInputs.MasrafDurum3 ??
        this.props.screenInputs.masrafdurum3,
      ucusliste_723449_checked: false,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  UcusListePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusListe/UcusListePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BirAyOncesiBirAySonrasi = result?.data.birAyOncesiBirAySonrasi;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusListePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusListePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusliste_191557_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        this.state.BirAyOncesiBirAySonrasi?.baslangic
      ),
      ReactSystemFunctions.convertToTypeByName("startValue", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusliste_191557_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        this.state.BirAyOncesiBirAySonrasi?.bitis
      ),
      ReactSystemFunctions.convertToTypeByName("endValue", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusliste_385716_value",
        "string"
      ),
      ReactSystemFunctions.getMyRoleNames(),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusListePageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusListePageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      yetkiStr_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_385716_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusListe/UcusListePageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetYetki = result?.data.getYetki;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusListePageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusListePageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.UcusListeComponent_135352_onClick()) return true;

    stateVars.isComp124894Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "onayDurumu"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp507444Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "onayDurumu"
        ),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp786878Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "masrafDurum"
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp790021Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "masrafDurum"
        ),
        "1"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp226151Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "masrafDurum"
        ),
        "2"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp216473Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "masrafDurum"
        ),
        "3"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp147697Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "masrafDurum"
        ),
        "4"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UcusListeComponent_981633_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusListe",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "139195",
      null,
      "left",
      "true",
      "450px",
      "",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusListeComponent_135352_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      OnayBekleyen_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_240898_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Onayli_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_153714_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      MasrafDurum0_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_56979_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      MasrafDurum1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_590992_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      MasrafDurum2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_667090_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      MasrafDurum3_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_64097_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      MasrafDurum4_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_364859_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BaslangicTarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_191557_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_191557_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      Silindi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusliste_723449_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusListe/UcusListeComponent_135352_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UcusListe = result?.data.ucusListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusListeComponent_135352_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusListeComponent_135352_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_399769 = stateVars.UcusListe ?? this.state.UcusListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusListeComponent_209173_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "UcusId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusliste_399769_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(1, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "RezervasyonNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "rezervasyonNo"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "MasrafMode",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusListe",
      "UcusForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusListeComponent_785184_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "UcusId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusliste_399769_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(2, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "RezervasyonNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "rezervasyonNo"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "MasrafMode",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusListe",
      "UcusForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusListeComponent_4782_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "UcusId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusliste_399769_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(2, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "RezervasyonNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "ucusliste_399769_value",
          "rezervasyonNo"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusForm",
      "MasrafMode",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusListe",
      "UcusForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.UcusListePageInit();
    }
  }
}
